import { Map as IMap } from "immutable";

import InitialState from "./InitialState";
import {
  STARTED,
  STOPPED,
  CLEAR,
  ADD_CLIENT,
  REMOVE_CLIENT,
  SELECT_CLIENT,
  DESELECT_CLIENT,
  START_LISTEN_FOR_CALLS,
  STOP_LISTEN_FOR_CALLS,
  OKTELL_WS_OPENED,
  OKTELL_WS_CLOSED,
  OKTELL_WS_ERROR,
  NEW_CALL_DETECTED,
  CALL_FINISHED,
  HANDLE_INCOMING_CALL,
  CHECK_NEW_CALLS_SUCCESS,
  CHECK_NEW_CALLS_REJECTED,
  HANDLE_INCOMING_CALL_SUCCESS,
  HANDLE_INCOMING_CALL_REJECTED,
  ACCEPT_INCOMING_CALL,
  MUTE_INCOMING_CALL,
  CLEAR_ONGOING_CALL,
  CREATE_SERVICE_DESK_REQUEST,
  CREATE_SERVICE_DESK_REQUEST_SUCCESS,
  CREATE_SERVICE_DESK_REQUEST_REJECTED,
  CLEAR_SUPPORT_TICKET_REQUEST,
  SET_PRIVILEGES,
  CALL_STATUS_STARTED,
  CALL_STATUS_FINISHED,
  SYNC_FOR_NEW_CALLS_ERROR,
} from "../CONSTANTS";

import Client, { getClientId, getClientDataRecord } from "../schema/Client";
import Call from "../schema/Call";

export default function reducer(state = new InitialState(), action) {
  switch (action.type) {
    case STARTED: {
      return state.set("started", true);
    }
    case STOPPED: {
      return state.set("started", false);
    }
    case CLEAR: {
      return new InitialState();
    }

    case ADD_CLIENT: {
      const { remoteId, type, data, select } = action.payload;
      const id = getClientId({
        remoteId,
        type,
      });
      const Data = getClientDataRecord({ type });
      const client = new Client({
        id,
        remoteId,
        type,
        data: new Data(data),
      });
      let newState = state.setIn(["savedClients", id], client);
      if (select) {
        newState = newState.set("currentClientId", id);
      }
      return newState;
    }

    case REMOVE_CLIENT: {
      const { id } = action.payload;
      let newState = state;

      // ending call
      const isCreatedFromCall = state.getIn(
        ["savedClients", id, "fromCall"],
        false
      );
      if (isCreatedFromCall) {
        newState = newState
          .set("incomingCall", false)
          .set("possibleClientsDataFetched", false)
          .set("callInProgress", false)
          .set("wrongClient", false);
      }

      // removing client
      if (state.get("currentClientId") === id) {
        newState = newState.set("currentClientId", null);
      }
      newState = newState.deleteIn(["savedClients", id]);
      return newState;
    }

    case SELECT_CLIENT: {
      const { id } = action.payload;
      return state.set("currentClientId", id);
    }

    case DESELECT_CLIENT: {
      return state.set("currentClientId", null);
    }

    // call management

    case OKTELL_WS_OPENED: {
      return state.set("oktellSync", true).set("oktellSyncStateChanges", false);
    }

    case OKTELL_WS_CLOSED: {
      return state
        .set("oktellSync", false)
        .set("oktellSyncStateChanges", false);
    }

    case OKTELL_WS_ERROR: {
      return state
        .set("oktellSync", false)
        .set("oktellSyncStateChanges", false);
    }

    case SYNC_FOR_NEW_CALLS_ERROR: {
      return state
        .set("oktellSync", false)
        .set("oktellSyncStateChanges", false);
    }

    case START_LISTEN_FOR_CALLS: {
      return state.set("oktellSyncStateChanges", true);
    }

    case STOP_LISTEN_FOR_CALLS: {
      return state.set("oktellSyncStateChanges", true);
    }

    case NEW_CALL_DETECTED: {
      // const isExistingCall = !!state.getIn(["calls", action.payload.phone]);
      // if (isExistingCall) {
      // }
      return state
        .setIn(
          ["calls", action.payload.callId],
          new Call({
            id: action.payload.callId,
            clientPhone: action.payload.clientPhone,
            operatorPhone: action.payload.operatorPhone,
            operatorName: action.payload.operatorName,
            status: CALL_STATUS_STARTED,
            client: null,
            possibleClients: new IMap(),
          })
        )
        .set("currentCall", action.payload.callId)
        .set("mostRecentCall", action.payload.callId)
        .set("showCallInfo", true);
    }

    case CALL_FINISHED: {
      const isExistingCall = !!state.getIn(["calls", action.payload.callId]);
      if (isExistingCall) {
        return state
          .setIn(
            ["calls", action.payload.callId, "status"],
            CALL_STATUS_FINISHED
          )
          .set("currentCall", null);
      } else {
        return state;
      }
    }

    case HANDLE_INCOMING_CALL: {
      return state.setIn(
        ["calls", action.payload.callId, "auxInfoLoading"],
        true
      );
    }

    case HANDLE_INCOMING_CALL_SUCCESS: {
      const possibleClients = action.payload.clients.map((client) => {
        return [client.id, new Client(client)];
      });
      return state
        .setIn(
          ["calls", action.payload.callId, "possibleClients"],
          new IMap(possibleClients)
        )
        .setIn(["calls", action.payload.callId, "auxInfoLoading"], false);
    }

    case HANDLE_INCOMING_CALL_REJECTED: {
      return state
        .setIn(["calls", action.payload.callId, "auxInfoLoading"], false)
        .setIn(["calls", action.payload.callId, "auxInfoLoadingError"], true);
    }

    case ACCEPT_INCOMING_CALL: {
      const { callId, clientId, clientNotFound } = action.payload;
      if (clientNotFound) {
        return state
          .setIn(["calls", callId, "clientNotFound"], clientNotFound)
          .set("showCallInfo", false);
      } else {
        const client = state.getIn([
          "calls",
          callId,
          "possibleClients",
          clientId,
        ]);
        return state
          .setIn(["calls", callId, "client"], client)
          .set("currentClientId", clientId)
          .setIn(["savedClients", clientId], client)
          .set("showCallInfo", false);
      }
    }

    case MUTE_INCOMING_CALL: {
      return state
        .setIn(["calls", action.payload.callId, "callMuted"], true)
        .set("showCallInfo", false);
    }

    case CHECK_NEW_CALLS_SUCCESS: {
      let newState = state;
      const currentNumber = newState.get("incomingPhoneNumber");
      if (!action.payload.success) {
        if (!action.payload.phone && currentNumber) {
          newState = newState.set("callDropped", true);
        }
        return newState;
      }

      newState = newState.set("incomingPhoneNumber", action.payload.phone);

      if (!action.payload.phone && currentNumber) {
        newState = newState.set("callDropped", true);
      }
      if (action.payload.phone && !currentNumber) {
        newState = newState.set("callDropped", false);
      }
      return newState;
    }

    case CHECK_NEW_CALLS_REJECTED: {
      return state.set("oktellSyncError", action.payload.error);
    }

    case CLEAR_ONGOING_CALL: {
      return state
        .set("incomingCall", false)
        .set("possibleClientsDataFetched", false)
        .set("callInProgress", false)
        .set("wrongClient", false);
    }

    case CREATE_SERVICE_DESK_REQUEST: {
      return state
        .set("sdRequestLoading", true)
        .set("sdRequestCompleted", false)
        .set("sdRequestError", null);
    }

    case CREATE_SERVICE_DESK_REQUEST_SUCCESS: {
      return state
        .set("sdRequestLoading", false)
        .set("sdRequestCompleted", true)
        .set("sdRequestError", null);
    }

    case CREATE_SERVICE_DESK_REQUEST_REJECTED: {
      return state
        .set("sdRequestLoading", false)
        .set("sdRequestCompleted", false)
        .set("sdRequestError", action.payload.error);
    }

    case CLEAR_SUPPORT_TICKET_REQUEST: {
      return state
        .set("sdRequestLoading", false)
        .set("sdRequestCompleted", false)
        .set("sdRequestError", null);
    }

    case SET_PRIVILEGES: {
      const { privileges } = action.payload;
      const currentClientId = state.get("currentClientId");
      if (currentClientId && privileges) {
        return state.setIn(
          ["savedClients", currentClientId, "privileges"],
          new IMap(privileges.entries())
        );
      } else {
        return state;
      }
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/reducer/reducer.js